module.exports = __webpack_public_path__ + "img/ico_video_muted_off.4bab3fe.svg";